module.exports = __webpack_public_path__ + "img/grand-palm-bar.8ff5c17c.jpg";